const Header = ({header}) => {
    return (
        <h1 className="fw-bold fs-2" style={{ color : "#214466"}}>{header}</h1>
    )
}

export default Header